import React, { useRef } from 'react';
import Rimg from './Rimg.jsx';
import SVG from './SVG.jsx';

export default function CollectionProductColors(props) {
  if (!props.thumbnails || props.thumbnails.length === 0) {
    return (null);
  }
  let cName = 'product-colors-wrapper';
  let limit = props.colorsPerPage - 1, label = null;
  if (props.colorsPerPage === props.thumbnails.length) {
    limit = props.colorsPerPage;
  } else if (props.thumbnails.length > props.colorsPerPage) {
    label = props.thumbnails.length - limit;
  }
  const thumbnails = [...props.thumbnails];
  thumbnails.push(thumbnails.splice(thumbnails.findIndex(thumbnail => thumbnail.handle === props.current), 1)[0]);
  if (props.layout === 'expanded') {
    return (
      <div className={cName}>
        <div className="product-colors" onMouseLeave={() => { props.setActiveThumb({}) }}>
          {thumbnails.map((thumbnail, i) => {
            if (i >= limit) {
              return (null);
            }
            let cName = 'product-color';
            return <a href={`/products/${thumbnail.handle}`} data-color-item={thumbnail.handle} title={thumbnail.title} className={cName} key={i} onMouseEnter={() => { props.setActiveThumb(thumbnail) }}>
              {thumbnail.image.src && <Rimg {...thumbnail.image} loading="lazy" />}
            </a>
          })}
          {label && <div className="product-color product-color-count">+{label}</div>}
        </div>
      </div>
    )
  }
  const scroller = useRef(null);
  if (props.thumbnails && props.thumbnails.length > props.colorsPerPage) {
    cName += ' show-scroller';
  }
  return (
    <div className={cName}>
      <button className="product-scroll-left product-scroll-trigger" onClick={() => {
        scroller.current.scrollBy({ top: 0, left: (-1 * scroller.current.clientWidth), behavior: 'smooth' });
      }}>
        <SVG icon="arrow-thin-left" />
      </button>
      <div className="product-colors" ref={scroller} onMouseLeave={() => { props.setActiveThumb({}) }}>
        {thumbnails.map((thumbnail, i) => {
          let cName = 'product-color';
          if (props.current === thumbnail.handle) {
            cName += ' current-color';
          }
          return <a href={`/products/${thumbnail.handle}`} data-color-item={thumbnail.handle} title={thumbnail.title} className={cName} key={i} onMouseEnter={() => { props.setActiveThumb(thumbnail) }}>
            {thumbnail.image.src && <Rimg {...thumbnail.image} loading="lazy" />}
          </a>
        })}
      </div>
      <button className="product-scroll-right product-scroll-trigger" onClick={() => {
        scroller.current.scrollBy({ top: 0, left: scroller.current.clientWidth, behavior: 'smooth' });
      }}>
        <SVG icon="arrow-thin-right" />
      </button>
    </div>
  )
}